import { ClientRole } from 'agora-rtc-sdk-ng';
import { connect } from 'react-redux';
import { RtcEngine } from '../../services/agora/rtcEngine';
import { RtmEngine } from '../../services/agora/rtmEngine';
import { ResponseEvent } from '../../services/api/models/response/responseEvent';
import {
  EventRanking,
  ResponseLiveInfo,
} from '../../services/api/models/response/responseLive';
import { ResponseUser } from '../../services/api/models/response/responseUser';
import {
  IResponseUserPairData,
  ResponseUserPairWantJoined,
} from '../../services/api/models/response/responseVoicePlus';
import { AppState } from '../../store/store';
import { Live } from './components/Live/Live';
import { MediaDevice } from './components/LiveSettings/LiveSettings';
import { actions } from './liveSlice';
import { LiveComment } from './models/liveComment';
import { LiveMember } from './models/liveMember';

type LiveActions = typeof actions;

export interface LiveProps extends LiveActions {
  liveState: LiveState;
}

export interface LiveState {
  rtcEngine?: RtcEngine;
  rtmEngine?: RtmEngine;
  liveData?: ResponseLiveInfo;
  role: ClientRole;
  isEnded: boolean;
  isBanEnded: boolean | undefined;
  isLive: boolean;
  joinId: string;
  isEnableGift: boolean;
  isUseStreamKey: boolean;

  mediaDevices: Array<MediaDevice>;
  inputVideoDevice?: string | undefined;
  inputAudioDevice?: string;
  outputAudioDevice?: string;

  // modal
  isShowTermModal: boolean;
  isShowGuidelineModal: boolean;
  isShowSettingModal: boolean;
  isShowVoiceGuestModal?: boolean;
  isShowSettingPairModal?: boolean;
  isInLive: boolean;
  isShowAllowChoice?: boolean;
  isShowRemoveUserPairModal: boolean;
  isShowNoticePairModal: boolean;

  // events
  name?: string;
  eventId?: string;
  subEventId?: string;
  liveCategoryId?: string;
  showEventModal: boolean;
  currentShowEvent?: ResponseEvent;
  eventRankings?: EventRanking[];

  // user
  userData?: ResponseUser;
  isLogin: boolean;
  liverLv: number;
  giftTopAudience?: ResponseUser;
  userCoin?: number;
  isShowProfileModal?: boolean;
  isShowConfirmBlockedModal?: boolean;

  // diamond
  gottenDiamond: number;
  gottenDiamondPool: number;
  isDiamondAnim: boolean;

  // member
  memberLastestUpdate: number;
  channelMemberList: Array<LiveMember>;
  liveComments: Array<LiveComment>;

  // settings
  isAudioMuted: boolean;
  isMirrorEnable: boolean;

  // board
  isShowListBoard: boolean;

  // missions
  isShowMissionModal: boolean;
  isReloadingMissionGiftTab?: boolean;
  // Belong Mobile Browser
  isShowLiveAudienceMobileSideModal: boolean;
  //pair
  isSendRequestPair: boolean;
  isAcceptPair: boolean;
  listPair: Array<ResponseUserPairWantJoined>;
  userPair?: IResponseUserPairData;
  pairType?: string;
  mediaDevicesGuest: Array<MediaDevice>;
  inputAudioDeviceGuest?: string;

  resizeStatus: boolean;
}

const mapStateToProps = (state: AppState) => ({
  liveState: state.live,
});

const mapDispatchToProps = {
  ...actions,
};

export const LiveContainer = {
  live: connect(mapStateToProps, mapDispatchToProps)(Live),
};
